import {Component} from 'react';
import Modal from 'react-bootstrap/Modal';
import './GameBoardActivities/gameBoardActivities.css'
import { TimerReturn } from "./objects/timerReturn";
import MazeGameModal from "./maze_game_modal";
import WordPuzzleModal from './word_puzzle_modal';
import GroceryStoreShopperInitialText from './text/grocery_store_shopper_initial_text';
import DragNDropModalGrocery from './drag_n_drop_modal_grocery';
import DragNDropCommonModal from './drag_n_drop_modal_common';
import {dragNDropBefore} from '../../objects/DragNDrop/drag_n_drop_before_function';
import FoodBankDragNDropInitialText from './text/food_bank_drag_n_drop_initial_text';
import CoatDriveInitialText from './text/coat_drive_initial_text';
import GoToZooInitialText from './text/go_to_zoo_initial_text';
import MazeActivityParameters from './Datasets/maze_activity_parameters';
import FoodBankDynamicDataset from './Datasets/food_bank_dynamic_dataset';
import JigsawPuzzleModal from './jigsaw_puzzle_modal';
import ComedyClubModal from './comedy_club_modal';
import MemoryGame from './memory_game';
import UndercoverPuzzleModal from './undercover_puzzle_modal';
import determineActivityModalType from './objects/determine_activity_modal_class';


class TimerDisplayModal extends Component {
     
    constructor(props) {
        super(props);
        this.state = {
            startTimer: false,
            stopActivity: false,
        }
        this.dragNDrop = {};
        this.dragNDropScore = 0;
        this.mazeParm = "";
    }

    determineActivityParameters(){
        switch(this.props.activityType) {
            case "maze":
                this.determineGifs();
                break;
            case "dragNdrop":
                this.determineDragNDropParameters();
                break;
            default:
                break;
        }
    }

    determineGifs(){
        this.mazeParameters = MazeActivityParameters;
        let mazeParmObject = MazeActivityParameters.find(elem => elem.gameName === this.props.activityShortName);
        if (mazeParmObject ){
            this.mazeParm = mazeParmObject.parms;
        }
    }

    determineDragNDropParameters(){
        if (this.props.activityShortName === "GroceryShopper"){
            this.groceryShopperDataset = "";
            this.correctMsg = "All items are correct.  Click 'Start' to fill another order."
            this.dragNDrop = dragNDropBefore ("Fill Shopper Orders",
                GroceryStoreShopperInitialText, "md", "", "", this.groceryShopperDataset,
                this.props.activityShortName, 99);
        }
        if (this.props.activityShortName === "FoodDrive"){
            this.foodBankDragNDropDataset = FoodBankDynamicDataset;
            this.itemClass = "foodbank_thumbnail_img";
            this.columnClass = "drag_n_drop_basic_column drag_n_drop_grocery_cart no-column-gutters ";
            this.columnTextClass = "text-center intro-text-font";
            this.multipleColumns = "multiple-columns";
            this.scoreType = "columnOnly";
            this.pictureDir = "./assets/Activities/Grocery/";
            this.backgroundClass = "";
            this.completedLit = "Food Carts Sorted";
            this.correctMsg = "All items have been sorted correctly.  Click 'Start' to get another batch of items."
            this.dragNDrop = dragNDropBefore ("Sort Donated Food into the Correct Basket",
                FoodBankDragNDropInitialText, "", "", "", this.foodBankDragNDropDataset,
                "FoodDrive", 99);
            this.friendContainerClass = "friend-container-foodbank friend-container-speech-gap";
        }
        if (this.props.activityShortName === "CoatDrive"){
            let coatDriveDataset = this.props.dndDataset;
            this.itemClass = "drag_n_drop_coat_img";
            this.columnClass = "drag_n_drop_coats_column drag_n_drop_blue_column no-column-gutters text-center";
            this.multipleColumns = "";
            this.columnTextClass = "text-center text-white intro-text-font";
            this.scoreType = "itemOrder";
            this.pictureDir = "./assets/Activities/Volunteer/Coats/";
            this.backgroundClass = "drag_n_drop_warehouse_background mt-2";
            this.completedLit = "Coats Assembled ";
            this.correctMsg = "All coats have been sorted correctly.  Click 'Start' to get another bin of coats.";
            this.dragNDrop = dragNDropBefore ("Put Coats Back Together",
                CoatDriveInitialText, "", "", "", coatDriveDataset, "CoatDrive", 99);
            this.friendContainerClass = "friend-container-coats friend-container-speech-gap";
        }
        if (this.props.activityShortName === "GoToZoo"){
            let zooAnimalsDataset = this.props.dndDataset;
            this.itemClass = "drag_n_drop_zoo_animal_img";
            this.columnClass = "drag_n_drop_zoo_column drag_n_drop_blue_column no-column-gutters text-center";
            this.multipleColumns = "";
            this.columnTextClass = "text-center text-white intro-text-font";
            this.scoreType = "itemOrder";
            this.pictureDir = "./assets/Activities/HaveFun/zooPictures/";
            this.backgroundClass = "drag_n_drop_zoo_background mt-2";
            this.completedLit = "Animals Found";
            this.correctMsg = "All animals have been found.  Click 'Start' to hunt for more animals."
            this.dragNDrop = dragNDropBefore ("Put Zoo Animals Back Together",
                GoToZooInitialText, "", "", "", zooAnimalsDataset, "GoToZoo", 99);
            this.friendContainerClass = "friend-container-zoo friend-container-speech-gap";
        }
    }
  
    startTimer(touchMode, addTime){   
        this.nbrSeconds = JSON.parse(JSON.stringify(this.props.timerInfo.nbrSeconds));
        if (touchMode === true){
            this.nbrSeconds += +addTime;
        }
        this.nbrMinutes = JSON.parse(JSON.stringify(this.props.timerInfo.nbrMinutes));
        this.setState({startTimer: true, stopActivity: false});
    }

    stopTimer(){
        this.setState({startTimer: false});
    }

    getTimeRemaining(time){
        this.remainingTime = time; 
    }

    endGame(score){
        score.timeRemaining = this.remainingTime;
        this.setState({startTimer: false});
        this.props.onClose(score);
    }

    turnOffTimer(){
        this.setState({stopActivity: true});
    }

    render() {
        this.determineActivityParameters();
        let modalSize = "";
        let modalClass = "";
        const modalTypes = 
        determineActivityModalType(this.props.activityType, this.props.friendInfo.friendName);
        this.gutters = modalTypes.modalSize;
        modalClass = modalTypes.modalClass;
     
     
    return <>
    <Modal show={this.props.show}  size={modalSize} dialogClassName={this.gutters} animation={false}>
        
        <Modal.Body className={modalClass}>
            {this.props.timerInfo.timerValid ? 
                <div className="row">
                    <div className="col-md-8">   
                        <h5 className="font-weight-bold">
                            {this.props.activityName} - Level {this.props.levelNbr}
                        </h5> 
                        <p>{this.props.rulesText}</p>
                        {this.state.startTimer ?
                            <TimerReturn initialMinute={this.nbrMinutes} 
                                initialSeconds={this.nbrSeconds}
                                postTime={(time)=> this.getTimeRemaining(time)}
                                clearInterval={() => this.turnOffTimer()}/>
                        :
                            <div className="mt-5"></div>
                        }
                    </div> 
                {this.props.image !== ""  ?
                    <div className="col-md-4 text-right">
                         <img src={this.props.image} className="small_size_img" alt="activityPicture"/>
                    </div>
                :        
                    <div className="col-md-4">
                        <div className="font_color_white">xxxxxxx</div>
                        <div className="font_color_white">xxxxxxxx</div>
                    </div>
                }
                </div>
            :
                null    
            }    
              {this.props.activityType === "maze"  ?
                <MazeGameModal className="modal"
                    width={this.props.mazeParameters.width}
                    height={this.props.mazeParameters.height}
                    pctBlocked={this.props.mazeParameters.pctBlocked}
                    category={this.props.activityCategory}
                    mazeParms={this.mazeParm}
                    timeAllowed={this.props.timerInfo.nbrSeconds}
                    nbrGames={this.props.nbrGames}
                    score={this.props.score}
                    friendInfo={this.props.friendInfo}
                    startTimer={(touchMode, addSeconds) => this.startTimer(touchMode, addSeconds)}
                    stopTimer={() => this.stopTimer()}
                    onGameOver={(score) => this.endGame(score)}  />
            :
                    null
            }

            {this.props.activityType === "wordPuzzle" ?
                <WordPuzzleModal className="modal"
                    wordList={this.props.wordList}
                    score={this.props.score}
                    activityShortName={this.props.activityShortName}
                    activityCategory={this.props.activityCategory}
                    stopActivity={this.state.stopActivity}
                    friendInfo={this.props.friendInfo}
                    onGameOver={(score) => this.endGame(score)}
                    startTimer={() => this.startTimer()}/>
           :
                    null
            } 
            
            {this.props.activityType === "jigsawPuzzle" ?  
                <JigsawPuzzleModal
                    levelNbr={this.props.levelNbr}
                    puzzleArr={this.props.jigsawParameters.puzzleArr}
                    pictureDir={this.props.jigsawParameters.pictureDir}
                    score={this.props.score}
                    friendInfo={this.props.friendInfo}
                    stopActivity={this.state.stopActivity}
                    nbrGames={this.props.nbrGames}
                    startTimer={() => this.startTimer()}
                    stopTimer={() => this.stopTimer()}
                    onGameOver={(score) => this.endGame(score)} 
                    onError={(errorMsg) => this.props.onError(errorMsg)}
                />
            :
                    null
            }  
                     
            {this.props.activityType === "comedyClub" ?  
                <ComedyClubModal
                    jokeList={this.props.comedyClubJokes}
                    activityCategory={this.props.activityCategory}
                    score={this.props.score}
                    friendInfo={this.props.friendInfo}
                    stopActivity={this.state.stopActivity}
                    startTimer={() => this.startTimer()}
                    stopTimer={() => this.stopTimer()}
                    onGameOver={(score) => this.endGame(score)} />
            :
                    null
            }  
        
            {this.props.activityType === "pictureReveal" ?
              <div>
                <UndercoverPuzzleModal
                    imageList={this.props.imageList}
                    score={this.props.score}
                    friendInfo={this.props.friendInfo}
                    activityCategory={this.props.activityCategory}
                    stopActivity={this.state.stopActivity}
                    startTimer={() => this.startTimer()}
                    stopTimer={() => this.stopTimer()}
                    onGameOver={(score) => this.endGame(score)} />
               </div>     
            :
                    null
            }  

            {this.props.activityShortName === "GroceryShopper" ?
              <DragNDropModalGrocery 
                    activityShortName={this.props.activityShortName}
                    modalSize={this.props.modalSize}
                    levelNbr={this.props.levelNbr}
                    modalTitle={this.dragNDrop.modalTitle}
                    introText={this.dragNDrop.introText}
                    correctMsg={this.correctMsg}
                    cookieNamePfx={this.dragNDrop.cookieNamePfx}
                    buttonType={this.dragNDrop.buttonType}
                    DNDParameters={this.props.DNDParameters}
                    nbrGames={this.props.nbrGames}
                    friendInfo={this.props.friendInfo}
                    score={this.props.score}
                    startTimer={() => this.startTimer()}
                    onGameOver={(score) => this.endGame(score)} />
            :
                    null
            }  

            {this.props.activityShortName === "CoatDrive" || this.props.activityShortName === "FoodDrive" 
                || this.props.activityShortName === "GoToZoo"  ?
              <DragNDropCommonModal
                    modalSize={this.props.modalSize}
                    activityShortName={this.props.activityShortName}
                    modalTitle={this.dragNDrop.modalTitle}
                    levelNbr={this.props.levelNbr}
                    introText={this.dragNDrop.introText}
                    cookieNamePfx={this.dragNDrop.cookieNamePfx}
                    itemClass={this.itemClass}
                    columnClass={this.columnClass}
                    columnTextClass={this.columnTextClass}
                    multipleColumns={this.multipleColumns}
                    pictureDir={this.pictureDir}
                    backgroundClass={this.backgroundClass}
                    completedLit={this.completedLit}
                    incrementNbr={this.incremenNbr}
                    correctMsg={this.correctMsg}
                    scoreType={this.scoreType}
                    dataset={this.dragNDrop.inputData}
                    DNDParameters={this.props.DNDParameters}
                    nbrGames={this.props.nbrGames}
                    score={this.props.score}
                    friendInfo={this.props.friendInfo}
                    friendContainerClass={this.friendContainerClass}
                    startTimer={() => this.startTimer()}
                    onGameOver={(score) => this.endGame(score)} />       
            :
                    null
            }  
             
            {this.props.activityType === "memoryGame"  ?
                <div className="" >
                    <MemoryGame
                        rulesText={this.props.rulesText}
                        levelNbr={this.props.levelNbr}
                        width={this.props.mazeParameters.width}
                        height={this.props.mazeParameters.height}
                        nbrGames={this.props.nbrGames}
                        activityName={this.props.activityName}
                        gameType={this.props.activityCategory}
                        score={this.props.score}
                        friendInfo={this.props.friendInfo}
                        onGameOver={(score) => this.endGame(score)}
                    />
                </div>
            :   
                null
            }
         </Modal.Body>
    </Modal>
            
    {/*  the following processes do not require a timer so they are not part of the timer modal */}            
           
           
         
           
    </>
    }

    componentDidMount(){
        this._isMounted = true;
        let el = document.querySelector('#container');
while (el) {
  if (el.scrollHeight > el.clientHeight) {
    console.log('OVERFLOW FOUND:', el, 
      '\nClass:', el.className, 
      '\nID:', el.id,
      '\nscrollHeight:', el.scrollHeight, 
      '\nclientHeight:', el.clientHeight);
  }
  el = el.firstElementChild;
}
    }

    componentWillUnmount(){
        this._isMounted = true;
    }

}

export default TimerDisplayModal;